import {
	useInfiniteQuery,
	type InfiniteData,
	type UseInfiniteQueryOptions,
} from '@tanstack/react-query';
import {
	getReviewsForAsset,
	getReviewsForAssetEndpoint,
	type QueryError,
	type GetReviewsForAssetResult,
	type GetReviewsForAssetRequestOptions,
} from '../getReviewsForAsset';
export * from '../getReviewsForAsset';

export type GetReviewsForAssetResultInfiniteData =
	InfiniteData<GetReviewsForAssetResult>;

// page params are handled via the infinite query `pageParams`
export type GetReviewsForAssetQueryParams = Omit<
	GetReviewsForAssetRequestOptions,
	'startIndex' | 'stopIndex'
>;

export type GetReviewsForAssetQueryKey = [
	string,
	GetReviewsForAssetQueryParams,
];

export type GetReviewsForAssetQueryOptions = Omit<
	UseInfiniteQueryOptions<
		GetReviewsForAssetResult,
		QueryError,
		GetReviewsForAssetResult,
		GetReviewsForAssetResult,
		GetReviewsForAssetQueryKey
	>,
	'queryKey' | 'queryFn'
>;

export const GetReviewsForAssetReactQueryKey = getReviewsForAssetEndpoint;

/**
 * react-query wrapper for `getReviewsForAsset`
 * @param queryKeyParams
 * @param options
 */
export const useReactQueryGetReviewsForAsset = (
	queryKeyParams: GetReviewsForAssetQueryParams,
	options?: GetReviewsForAssetQueryOptions,
) =>
	useInfiniteQuery<
		GetReviewsForAssetResult,
		QueryError,
		GetReviewsForAssetResult,
		GetReviewsForAssetQueryKey
	>({
		queryKey: [getReviewsForAssetEndpoint, queryKeyParams],
		queryFn: ({queryKey, pageParam, signal}) =>
			getReviewsForAsset({...queryKey[1], ...pageParam}, signal),
		...options,
	});

export default useReactQueryGetReviewsForAsset;
